import VueProgressBar from 'vue-progressbar';
import { colors, appStyles } from '@/constants';

export default function (Vue) {
  Vue.use(VueProgressBar, {
    color: colors.progressBar,
    failedColor: colors.warning,
    thickness: appStyles.headerProgressHeight,
  });
}
